'use strict';

/**
 * Strategy
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.Strategy = T.createModule({

	_selectors: {
		lightboxTrigger: '[data-js-o-strategy__lightbox-trigger]',
		contentHolder: '[data-js-o-strategy__lightbox-content-holder]'
	},

	start: function start(resolve) {

		// References
		this.$ctx = $(this._ctx);
		this.$lightboxTrigger = $(this._selectors.lightboxTrigger);

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));
		resolve();
	},
	sync: function sync() {
		this.initLightbox();
	},


	/**
  *  Initializing Magnific Popup Lightbox
  *
  * @returns {undefined} void
  */
	initLightbox: function initLightbox() {
		var _this = this;

		// Fail if jQuery Plugin not available
		if (!$.magnificPopup) {
			return;
		}

		$.each(this.$lightboxTrigger, function (index, trigger) {
			var $trigger = $(trigger);
			var $contentHolder = $trigger.siblings(_this._selectors.contentHolder);

			// Fail if tile lightbox content holder not found
			if (!$contentHolder.length) {
				return;
			}

			$trigger.magnificPopup({
				items: {
					src: $contentHolder,
					type: 'inline'
				},
				midClick: true,
				mainClass: 'o-strategy__lightbox',
				closeMarkup: "<button title='%title%' type='button' class='mfp-close'><svg class='a-icon a-icon--primary i i-close'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#close'></use></svg></button>",
				fixedContentPos: true,
				fixedBgPos: true
			});
		});
	}
});